import { checkSession } from "../utils/session";
import { server_error_label } from "./server-error";

export default async function httpRequest(
  context,
  updateContext,
  navigate,
  requestFetch,
  method,
  url,
  params,
  token,
  session_checking,
  tokenActiveDirectory
) {
  const obj = {
    method: method,
    headers: {},
  };

  const is_file = params instanceof File;

  if (!is_file) obj.headers["Content-Type"] = "application/json";
  if (["post", "put"].includes(method.toLowerCase()))
    obj["body"] = is_file ? params : JSON.stringify(params);
  if (token || tokenActiveDirectory) obj.headers["Authorization"] = `Bearer ${token? token : tokenActiveDirectory}`;

  let complete_url = !url.includes("http")
    ? `${process.env.REACT_APP_Q8FA_API_URL}/${url}`
    : url;

  let request;

  if (navigator.onLine) {
    request = await fetch(complete_url, obj)
      .then((response) => {
        if (response.ok) return is_file ? response : response.json();
        return Promise.reject(response);
      })
      .then((res) => {
        if (!is_file) {
          let data = checkDataStructure(res, false, context);    
          if ([401, 403].includes(data.status) && !session_checking) {
            checkSession(updateContext, navigate, requestFetch,tokenActiveDirectory);
          }

          return data;
        }
        return res;
      })
      .catch((response) => {
        if (response?.json !== null && response?.json !== undefined) {
          let data = response
            .json()
            .then((json) => {
              if (json) return checkDataStructure(json, true, context);
            })
            .catch(() => {
              return { result: false, data: null };
            });
          return data;
        }
        return { result: false, data: null };
      });

    if (method.toLowerCase() === "get")
      localStorage.setItem(url, JSON.stringify(request));
  } else {
    let local_response = localStorage.getItem(url);

    request = local_response
      ? JSON.parse(local_response)
      : { result: false, data: null };
  }

  return request;
}

const checkDataStructure = (json, is_error, context) => { 
  let data = { ...json };
  if (!!data && !!data.result) data.result = data.result.toLowerCase() === "ok";
  else data = { result: !is_error, data: data };

  if (!!data.error) {
    let message =
      server_error_label[data.error.errorMsg] || data.error.errorMsg;
    context.openMessage("danger", message);
  }
  return data;
};
